export enum UserRolesId {
  Admin = 1,
  Customer = 3,
  Provider = 4,
  Sponsor = 5
}